import React, { useMemo, useState } from "react";
import { createProduction } from "../../../../services/productionServices";
import { toast } from "react-toastify";
import Select from "react-select";

const ProductionModal = ({ isOpen, onClose, products, onProductionSaved }) => {
  const [productId, setProductId] = useState("");
  const [qty, setQty] = useState(1);
  const [saving, setSaving] = useState(false);

  const bakeryProducts = useMemo(
    () => (products || []).filter((product) =>
      String(product?.category || "").trim().toLowerCase() === "bakery product"
    ),
    [products]
  );

  const productOptions = useMemo(
    () => bakeryProducts.map((product) => ({ value: String(product.id), label: product.name })),
    [bakeryProducts]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!productId || !qty || Number(qty) <= 0) {
      toast.error("Select a product and quantity.");
      return;
    }
    setSaving(true);
    try {
      await createProduction({ product_id: Number(productId), qty: Number(qty) });
      toast.success("Production recorded.");
      setProductId("");
      setQty(1);
      onProductionSaved?.();
      onClose?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to record production.");
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold" style={{ color: "var(--color-text)" }}>Record Production</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Product</label>
            <div className="mt-1">
              <Select
                value={productOptions.find((option) => option.value === String(productId)) || null}
                onChange={(selected) => setProductId(selected?.value || "")}
                options={productOptions}
                placeholder="Search bakery product..."
                isClearable
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    borderRadius: "0.5rem",
                    borderColor: "#e5e7eb",
                    minHeight: "40px",
                  }),
                  valueContainer: (base) => ({ ...base, padding: "0 12px" }),
                  input: (base) => ({ ...base, margin: 0, padding: 0 }),
                }}
              />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Quantity Produced</label>
            <input
              type="number"
              min="1"
              className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
            />
          </div>
          <div className="flex items-center justify-end gap-3">
            <button type="button" onClick={onClose} className="text-sm text-gray-600 hover:text-gray-800">
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-sm font-medium hover:bg-emerald-700"
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProductionModal;
